var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.97832 0C5.87024 0.0255025 3.85566 0.876545 2.36492 2.37134C0.87417 3.86614 0.0254334 5.88619 0 8C0.0254334 10.1138 0.87417 12.1339 2.36492 13.6287C3.85566 15.1235 5.87024 15.9745 7.97832 16C10.0864 15.9745 12.101 15.1235 13.5917 13.6287C15.0825 12.1339 15.9312 10.1138 15.9566 8C15.9312 5.88619 15.0825 3.86614 13.5917 2.37134C12.101 0.876545 10.0864 0.0255025 7.97832 0ZM12.5374 8.57143H8.5482V12.5714H7.40844V8.57143H3.41928V7.42857H7.40844V3.42857H8.5482V7.42857H12.5374V8.57143Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.93fddf3f4e6157d6642e09b343547772.svg";
export { ForwardRef as ReactComponent };